var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.43061 6.00803L1.21246 2.30246C1.14814 2.23502 1.09623 2.15341 1.05979 2.06245C1.02336 1.9715 1.00314 1.87305 1.00034 1.77294C0.997535 1.67282 1.0122 1.57308 1.04348 1.47961C1.07475 1.38615 1.12199 1.30085 1.1824 1.22878C1.24281 1.15671 1.31517 1.09933 1.39518 1.06003C1.4752 1.02074 1.56125 1.00033 1.64824 1C1.73523 0.999683 1.82139 1.01946 1.90162 1.05817C1.98185 1.09687 2.05452 1.15372 2.11534 1.22534L2.13118 1.24358L5.80957 5.47809C5.9315 5.61851 6 5.80895 6 6.00753C6 6.2061 5.9315 6.39654 5.80957 6.53697L2.13206 10.7715C2.07271 10.8422 2.00186 10.8988 1.92353 10.938C1.8452 10.9772 1.76093 10.9982 1.67554 10.9999C1.59014 11.0016 1.5053 10.9839 1.42584 10.9478C1.34639 10.9118 1.27388 10.858 1.21246 10.7897C1.15103 10.7214 1.1019 10.6398 1.06786 10.5496C1.03383 10.4594 1.01555 10.3624 1.01408 10.264C1.01261 10.1657 1.02797 10.068 1.05929 9.97653C1.09061 9.88504 1.13727 9.80155 1.19662 9.73083L1.21246 9.71259L4.43061 6.00803Z",
    fill: "#01249B",
    fillOpacity: 0.66,
    stroke: "#01249A",
    strokeOpacity: 0.66,
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrop);
export default __webpack_public_path__ + "static/media/drop.e87c9c9bdff0cb1fa27c8bc9746e7e15.svg";
export { ForwardRef as ReactComponent };